import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import {
  FETCH_PAYMENT_RECEIPT,
  FETCH_PAYNOW_PAYMENT_RECEIPT,
  FETCH_BANK_TRANSFER_PAYMENT_RECEIPT,
  fetchPaymentReceiptSuccess,
  fetchPaymentReceiptError,
  fetchPaymentReceiptForOfflineSuccess,
} from '@dragonfruit/redux/purchase/paymentReceipt';
import { getToken } from '@dragonfruit/redux/auth';
import { actions as errorActions } from '@dragonfruit/redux/error';

import {
  apiFetchAddon,
  apiGetPaymentOrderDetailWithoutToken,
  apiGetPaymentOrderDetailWithToken,
} from '@dragonfruit/services/apis';

import { PAYMENT_WAITING } from '@dragonfruit/constants/paymentStatus';
import { BANK_TRANSFER, PAYNOW } from '@dragonfruit/constants/paymentTypes';
import { yearMonthDayFormat } from '@dragonfruit/utils/dateParser';
import { formatPriceWithCurrency } from '@dragonfruit/utils/priceParser';
import { getFirstSelectedCollection } from '@dragonfruit/sagas/purchase/transformCheckoutCollection';

export function* fetchPaymentReceiptFlow(action) {
  // * receiptNumber may be order number or payment method ID
  const { receiptNumber } = action.payload;

  const token = yield select(getToken);

  try {
    const apiPaymentOrderDetail = token
      ? apiGetPaymentOrderDetailWithToken
      : apiGetPaymentOrderDetailWithoutToken;

    const { payment, deliveryInfo, isSemester } = yield call(
      apiPaymentOrderDetail,
      receiptNumber
    );

    // * If the payment is null, receiptNumber is possible to be payment method ID.
    // * Since bank transfer will not create order, we use payment method ID to
    // * get the plan information as receipt detail.

    if (!payment) {
      return yield call(fetchPaymentReceiptForOfflineFlow, {
        payload: { paymentMethodId: receiptNumber, paymentType: BANK_TRANSFER },
      });
    }

    const {
      currency,
      displayCurrency,
      expiredAt,
      paymentType,
      planName,
      bankId,
      bankName,
      writeoffNumber,
      amount,
      status,
    } = payment;

    yield put(
      fetchPaymentReceiptSuccess({
        planName,
        isSemester,
        paymentType,
        paymentStatus: status,
        total: formatPriceWithCurrency(currency, displayCurrency, +amount),
        expiredAt: yearMonthDayFormat(expiredAt),
        bankId,
        bankName,
        writeoffNumber,
        deliveryInfo,
      })
    );
  } catch (err) {
    yield put(fetchPaymentReceiptError(err.message));
    yield put(errorActions.sendError(err));
  }
}

export function* fetchPayNowPaymentReceiptFlow(action) {
  // receiptNumber will be payment method ID
  const { receiptNumber } = action.payload;

  return yield call(fetchPaymentReceiptForOfflineFlow, {
    payload: { paymentMethodId: receiptNumber, paymentType: PAYNOW },
  });
}

export function* fetchBankTransferPaymentReceiptFlow(action) {
  // receiptNumber will be payment method ID
  const { receiptNumber } = action.payload;

  return yield call(fetchPaymentReceiptForOfflineFlow, {
    payload: { paymentMethodId: receiptNumber, paymentType: BANK_TRANSFER },
  });
}

export function* fetchPaymentReceiptForOfflineFlow(action) {
  const { paymentMethodId, paymentType } = action.payload;

  const { checkoutCollections = [] } = yield call(apiFetchAddon, {
    payment_method_id: paymentMethodId,
  });

  const selectedCollectionPlan = getFirstSelectedCollection(checkoutCollections)
    .plan;
  const isSemester = checkoutCollections.some(({ isSemester }) => isSemester);

  const { name: planName, paymentMethods } = selectedCollectionPlan;

  const targetPaymentMethod = paymentMethods.find(
    ({ id }) => id === +paymentMethodId
  );

  const { currency, displayCurrency, price } = targetPaymentMethod;

  yield put(
    fetchPaymentReceiptForOfflineSuccess({
      planName,
      paymentStatus: PAYMENT_WAITING,
      paymentType,
      isSemester,
      total: formatPriceWithCurrency(currency, displayCurrency, +price),
    })
  );
}

export default function*() {
  yield all([takeLatest(FETCH_PAYMENT_RECEIPT, fetchPaymentReceiptFlow)]);
  yield all([
    takeLatest(FETCH_PAYNOW_PAYMENT_RECEIPT, fetchPayNowPaymentReceiptFlow),
  ]);
  yield all([
    takeLatest(
      FETCH_BANK_TRANSFER_PAYMENT_RECEIPT,
      fetchBankTransferPaymentReceiptFlow
    ),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/purchase/paymentReceipt.js